export const ONE_DAY = 24 * 3600 * 1000;

export const NOW_DATE = new Date();

export const NOW = NOW_DATE.toISOString();

export const LATER_DATE = new Date(NOW_DATE.getTime() + 30 * ONE_DAY);

export const LATER = LATER_DATE.toISOString();
